import axiosClient from "./axiosClient";

export async function fetchCartDeliveryQuote(addressId) {
  const response = await axiosClient.get("/deliverypricing/cart-quote", { params: { addressId } });
  return response.data;
}
